import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactImageResize from "react-image-file-resizer";

const Register = () => {
  const navigate = useNavigate();
  const [image, setImage] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [nameError, setNameError] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message

  const handleSubmit = async (e) => {
    e.preventDefault();

    const password1 = e.target.password1.value;
    const password2 = e.target.password2.value;

    if (password1 !== password2) {
      setPasswordsMatch(false);
      return;
    }

    const formData = new FormData();
    formData.append("email", e.target.email.value);
    formData.append("password", password1);
    formData.append("name", e.target.name.value);
    formData.append("phone_number", e.target.phone_number.value);
    formData.append("image", image);
    let responce;
    try {
      responce = await axios.post(
        "https://pfebackend-zbz0.onrender.com/api/register/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }

    navigate("/verifyemail");
  };

  const handleAddPicture = (e) => {
    const file = e.target.files[0];
    setImage(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = document.getElementById("profile-pic-preview");
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validatePhone = (phone) => {
    const re = /^\d{10}$/;
    return re.test(phone);
  };

  const validateName = (name) => {
    const re = /^[a-zA-Z ]*$/;
    return re.test(name);
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
    }
  };

  const handlePhoneChange = (e) => {
    const phone = e.target.value;
    if (!validatePhone(phone)) {
      setPhoneError("Please enter a valid 10-digit phone number.");
    } else {
      setPhoneError("");
    }
  };

  const handleNameChange = (e) => {
    const name = e.target.value;
    if (!validateName(name)) {
      setNameError("Please enter a valid name.");
    } else {
      setNameError("");
    }
  };

  return (
    <div className="register-container">
      <div className="link-log-reg-container">
        <h1>Create an account</h1>
      </div>

      {errorMessage && <div className=" erroremailexiste">{errorMessage}</div>}
      <form className="registration-form" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            onChange={handleEmailChange}
            style={{ borderColor: emailError ? "red" : "" }}
          />
          {emailError && <p style={{ color: "red" }}>{emailError}</p>}
        </div>
        <div>
          <label htmlFor="password1">Password *</label>
          <input type="password" id="password1" name="password1" required />
        </div>
        <div>
          <label htmlFor="password2">Confirm Password *</label>
          <input
            type="password"
            id="password2"
            name="password2"
            required
            onChange={() => setPasswordsMatch(true)}
            style={{ borderColor: passwordsMatch ? "" : "red" }}
          />
          {!passwordsMatch && (
            <p style={{ color: "red" }}>Passwords do not match.</p>
          )}
        </div>

        <div>
          <label htmlFor="name">Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            className={nameError ? "error" : ""}
            onChange={(e) => handleNameChange(e)}
          />
          {nameError && <p className="error-message">{nameError}</p>}
        </div>
        <div>
          <label htmlFor="phone_number">Phone Number *</label>
          <input
            type="text"
            id="phone_number"
            name="phone_number"
            required
            className={phoneError ? "error" : ""}
            onChange={(e) => handlePhoneChange(e)}
          />
          {phoneError && (
            <p style={{ color: "red" }} className="error-message">
              {phoneError}
            </p>
          )}
        </div>
        <input type="submit" value="Register" />
      </form>
      <div className="link-log-reg-container">
        <Link className="register-goto-login-link" to={"/login"}>
          <span className="aling">already in</span>? Login
        </Link>
      </div>
    </div>
  );
};

export default Register;
